import { IdField } from '@/core/ts-decorators/model-decorators';
import { BaseModel } from '../core/models';

export interface IIndexesState {
  indexes: Index[];
  indexesLite: IndexLite[];
  IndexProperties: Index | null;
  librariesContents: Record<string, Record<string, IDirectoryItem>>;
  sentenceList: any[]; //todo now is used just for check the document view can be upgraded or deleteted
  documentPageImageBase64: string; //todo now is used just for check the document view can be upgraded or deleteted
  documentDetails: IIndexedDocumentData | null; //todo now is used just for check the document view can be upgraded or deleteted
  isCreateIndexDialogVisible: boolean;
  isUpdateIndexDialogVisible: boolean;
  showLibraryList: boolean;
  libraries: ILibrary[];
  libraryOnFocus: null | ILibrary;
  sourceToIndex: IndexerConfigurationModel;
  indexesIds: IndexIdLite[];
  newlyCreatedIndex: number;
  documentTotalPages: number;
  documentFileName: string;
}

export class Index extends BaseModel {
  @IdField()
  id: number = 0;
  name: string = '';
  description: string | null = null;
  directory: string = '';
  directoryType: string = '';
  status: number = 0;
  driveId: string = '';
  siteId: string = '';
  metadata: string = '';
  totalDocuments: number = 7835; // todo
  searchKeyVault?: string | null;
  titleFieldName?: string | null;
  contentFieldNames?: string | null;
  vectorFieldNames?: string | null;
  urlFieldName?: string | null;
  semanticConfiguration?: string | null;
  shouldRestrictResultScope?: string;
}

export class IndexIdLite {
  id: number = 0;
}

export class IndexerConfigurationModel {
  //db data
  id: number = 0;
  name: string | undefined;
  description: string | undefined = undefined;
  metadata: string | null = null;
  directory: string = '';
  searchKeyVault?: string | null;
  titleFieldName?: string | null;
  contentFieldNames?: string | null;
  vectorFieldNames?: string | null;
  urlFieldName?: string | null;
  semanticConfiguration?: string | null;
  shouldRestrictResultScope?: string;

  //Master
  library: string = '';
  limit: number = 500;
  lastUpdate: string = '2000-01-01';

  //Pipeline
  enableGenerateThumbnail: boolean = true;
  enableCopyFileToLake: boolean = true;
  enableCopyLogsToLake: boolean = true;
  enableCopyErrorsToLake: boolean = true;
  orderedTextCrackers: TextCracker[] = [
    { name: 'AzureDocumentIntelligence', connectionKey: 'AzureAIDocument;OpenAIModel41', fileTypes: null },
    { name: 'Tika', connectionKey: null, fileTypes: null },
    { name: 'Iron', connectionKey: null, fileTypes: null },
  ];

  //Push
  countLimit: number = 10;
  memoryLimit: number = 100;
  waitSec: number = 10;
  initDestination: boolean = true;
  searchservice: string = 'ragdemonuovo';
  driveId?: string;
}

export interface TextCracker {
  name: string;
  connectionKey: string | null;
  fileTypes: string | null;
}

export interface ILibrary {
  name: string;
  driveId: string;
  siteId: string;
  createdAt: string;
  lastModified: string;
  directory: string;
}

export class IndexDocument extends BaseModel {
  @IdField()
  id: string = '';
  title: string = '';
  content: string = '';
  url: string = '';
  titleVector: number[] = [];
  contentVector: number[] = [];
  category: string = '';
  chunkType: string = '';
  pageNumber: number = 0;
  positionOnPage: string = '';
  imageBase64: string = '';
  documentId: string = '';
  documentTitle: string = '';
  documentUrl: string = '';
  documentAuthor: string = '';
  docuementDate: string = '';

  get tags(): string[] {
    return [this.chunkType, this.category].filter(Boolean);
  }
}

export interface IDirectoryContentRequest {
  driveId: string;
  folderId: string | null;
}

export interface IDirectoryItem {
  name: string;
  size: string;
  updatedAt: string;
  updatedBy: string;
  type: string | null;
  driveId: string;
  eTag: string;
  id: string;
  childrens: Record<string, IDirectoryItem> | null;
  path: string[];
  isLoaded?: boolean;
  indexingStatus?: 'Da indicizzare' | 'In corso' | 'Completato' | 'Errore';
  indexingDate?: string;
}

export interface IIndexedDocumentData {
  name: string;
}

export class IndexLite {
  id: number = 0;
  name: string = '';
}

export class ChunksPayload {
  fileId: string = '';
  driveId: string = '';
  pageNumber: number = 1;
}

export class IndexDocumentAndChunks {
  documents: IndexDocument[] = [];
  imageBase64: string = '';
  totalPages: number = 0;
  fileName: string = '';
}
